"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _Selectors = require("../constants/Selectors");

var _decorators = require("../utils/propTypes/decorators");

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var USE_CLASSES = {
  default: '',
  'full-card': 'private-hoverlay--full-card',
  'bottom-half-card': 'private-hoverlay--bottom-half-card'
};

var UIHoverlay = _react.default.createClass({
  displayName: "UIHoverlay",
  propTypes: {
    _blur: _react.PropTypes.bool,
    children: _react.PropTypes.element,
    foregroundContent: _react.PropTypes.node,
    hovered: (0, _decorators.hidden)(_react.PropTypes.bool),
    href: _react.PropTypes.oneOfType([_validHref.default]),
    linkComponent: CustomRenderer.propType,
    overlayClassName: _react.PropTypes.string,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES))
  },
  getDefaultProps: function getDefaultProps() {
    return {
      _blur: true,
      linkComponent: _UILink.default,
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasFocus: false,
      hasTabbableContent: false
    };
  },
  refCallback: function refCallback(el) {
    if (!el) {
      return;
    }

    var hasTabbableContent = el.querySelector(_Selectors.FOCUSABLE);
    this.setState({
      hasTabbableContent: hasTabbableContent
    });
  },
  handleBlur: function handleBlur() {
    this.setState({
      hasFocus: false
    });
  },
  handleFocus: function handleFocus() {
    this.setState({
      hasFocus: true
    });
  },
  getChildrenClassName: function getChildrenClassName(_ref) {
    var _blur = _ref._blur;
    return (0, _classNames.default)('private-hoverlay__children', {
      'private-hoverlay__children--blur': _blur
    }, {
      'private-hoverlay--blur': _blur
    });
  },
  getOverlayClassName: function getOverlayClassName(_ref2) {
    var hasFocus = _ref2.hasFocus,
        hovered = _ref2.hovered,
        href = _ref2.href,
        onClick = _ref2.onClick,
        overlayClassName = _ref2.overlayClassName;
    return (0, _classNames.default)(overlayClassName, 'uiOverlay-backdrop', 'private-hoverlay__overlay', 'private-overlay--contextual', {
      'private-hoverlay__overlay--clickable': href || onClick,
      'private-hoverlay__overlay--focused': hasFocus,
      'private-hoverlay__overlay--hovered': hovered
    });
  },
  getOverlayContentClassName: function getOverlayContentClassName() {
    return (0, _classNames.default)('private-overlay__overlay-content', 'private-hoverlay__foreground-content');
  },
  renderLinkOverlay: function renderLinkOverlay(_ref3, _ref4) {
    var href = _ref3.href,
        linkComponent = _ref3.linkComponent;
    var renderedOverlay = _ref4.renderedOverlay;
    return CustomRenderer.render(linkComponent, {
      children: renderedOverlay,
      className: 'display-block',
      href: href,
      use: 'unstyled'
    });
  },
  renderButtonOverlay: function renderButtonOverlay(_ref5, _ref6) {
    var onClick = _ref5.onClick;
    var renderedOverlay = _ref6.renderedOverlay;
    return _react.default.createElement(_UIClickable.default, {
      className: "private-hoverlay__button",
      onClick: onClick
    }, renderedOverlay);
  },
  renderOverlay: function renderOverlay(_ref7) {
    var _blur = _ref7._blur,
        children = _ref7.children,
        foregroundContent = _ref7.foregroundContent,
        hasFocus = _ref7.hasFocus,
        hovered = _ref7.hovered,
        href = _ref7.href,
        onClick = _ref7.onClick,
        overlayClassName = _ref7.overlayClassName;
    var wrappedForegroundContent = foregroundContent == null ? null : _react.default.createElement("div", {
      className: this.getOverlayClassName({
        hasFocus: hasFocus,
        hovered: hovered,
        href: href,
        onClick: onClick,
        overlayClassName: overlayClassName
      })
    }, _react.default.createElement(_UIFlex.default, {
      align: "stretch",
      direction: "column",
      justify: "start",
      className: this.getOverlayContentClassName()
    }, foregroundContent));
    return _react.default.createElement("span", null, wrappedForegroundContent, _react.default.createElement("div", {
      className: this.getChildrenClassName({
        _blur: _blur
      })
    }, (0, _react.cloneElement)(children, {
      className: (0, _classNames.default)('private-hoverlay__child', children.props.className)
    })));
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        _blur = _this$props._blur,
        className = _this$props.className,
        children = _this$props.children,
        foregroundContent = _this$props.foregroundContent,
        __hovered = _this$props.hovered,
        href = _this$props.href,
        linkComponent = _this$props.linkComponent,
        onClick = _this$props.onClick,
        overlayClassName = _this$props.overlayClassName,
        tabIndex = _this$props.tabIndex,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["_blur", "className", "children", "foregroundContent", "hovered", "href", "linkComponent", "onClick", "overlayClassName", "tabIndex", "use"]);
    var hasFocus = this.state.hasFocus;

    if (href && onClick) {
      _devLogger.default.warn({
        message: 'UIHoverlay: Cannot have both onClick and href props.'
      });
    }

    return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
      var hovered = hoverProviderProps.hovered,
          hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);

      var renderedOverlay = _this.renderOverlay({
        _blur: _blur,
        children: children,
        foregroundContent: foregroundContent,
        hasFocus: hasFocus,
        hovered: hovered,
        href: href,
        onClick: onClick,
        overlayClassName: overlayClassName
      });

      var renderedHoverlay;

      if (href) {
        renderedHoverlay = _this.renderLinkOverlay({
          href: href,
          linkComponent: linkComponent
        }, {
          renderedOverlay: renderedOverlay
        });
      } else if (onClick) {
        renderedHoverlay = _this.renderButtonOverlay({
          onClick: onClick
        }, {
          renderedOverlay: renderedOverlay
        });
      } else {
        renderedHoverlay = renderedOverlay;
      }

      var classes = (0, _classNames.default)(className, 'private-hoverlay', USE_CLASSES[use], {
        'is--module': use === 'full-card'
      });
      var computedTabIndex;

      if (tabIndex != null) {
        computedTabIndex = tabIndex;
      } else {
        computedTabIndex = _this.state.hasTabbableContent ? null : 0;
      }

      return _react.default.createElement("div", (0, _extends2.default)({}, rest, hoverProviderRestProps, {
        className: classes,
        onBlur: _this.handleBlur,
        onFocus: _this.handleFocus,
        ref: _this.refCallback,
        tabIndex: computedTabIndex
      }), renderedHoverlay);
    });
  }
});

var _default = UIHoverlay;
exports.default = _default;
module.exports = exports.default;